import classNames from 'clsx';
import React, { memo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { NEW_PORTAL_HEADER } from 'reactApp/appHelpers/configHelpers';
import { downloadAndViewCounterTariff } from 'reactApp/appHelpers/featuresHelpers/features/downloadAndViewCounterTariff';
import { useAlbumId } from 'reactApp/hooks/useAlbumId';
import { useVigboTariff } from 'reactApp/hooks/useVigboTariff';
import { routeChangeSuccess } from 'reactApp/modules/router/router.module';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { loadVigboAlbumRequest } from 'reactApp/modules/vigbo/vigbo.module';
import { getCurrentVigboAlbum } from 'reactApp/modules/vigbo/vigbo.selectors';
import { BreadcrumbsContainer } from 'reactApp/ui/BreadcrumbsContainer/BreadcrumbsContainer';
import { DataList } from 'reactApp/ui/Datalist/DataList';
import { DownloadAndViewCounter } from 'reactApp/ui/DownloadAndViewCounter/DownloadAndViewCounter';
import { Spinner } from 'reactApp/ui/Spinner/Spinner';
import { noop } from 'reactApp/utils/helpers';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';
import { filesPlural } from 'reactApp/utils/pluralHelpers';

import styles from './VigboAlbumPage.css';

export const VigboAlbumPage = memo(function VigboAlbumPage() {
    const dispatch = useDispatch();
    const { albumId, initialItemId } = useAlbumId();

    const currentAlbum = useSelector(getCurrentVigboAlbum);
    const photosCount = currentAlbum?.photosCount || 0;

    const showDownloadAndViewCounter = downloadAndViewCounterTariff?.variant !== 'a' && currentAlbum?.weblink;

    useEffect(() => {
        sendPaymentGa({ eventCategory: ECategoryGa.entered, action: 'vigbo-album' });
        sendPaymentGa({ eventCategory: ECategoryGa.entered, action: 'page-entered', source: 'vigbo-album' });

        dispatch(routeChangeSuccess({ id: albumId, storage: EStorageType.vigbo, params: {}, __isFolder: true, url: '', __parent: '' }));
        dispatch(loadVigboAlbumRequest({ albumId }));
    }, [albumId]);

    const { isLoading, isVigboActiveTariff, isVigboFinishedTariff } = useVigboTariff();

    if (isLoading) {
        return <Spinner />;
    }

    if (!isVigboActiveTariff && !isVigboFinishedTariff) {
        return <Navigate replace to="/home/" />;
    }

    return (
        <div
            className={classNames(styles.root, {
                [styles.root_new_portal_header]: NEW_PORTAL_HEADER,
            })}
        >
            <div className={classNames({ [styles.headerContainer_new_portal_header]: NEW_PORTAL_HEADER })}>
                <BreadcrumbsContainer />
                {photosCount > 0 && (
                    <div className={styles.filesCountWrapper}>
                        <div className={styles.filesCount}>
                            {photosCount} {filesPlural(photosCount)}
                        </div>
                        {showDownloadAndViewCounter && <DownloadAndViewCounter />}
                    </div>
                )}
            </div>
            <div className={classNames({ [styles.datalistContainer_new_portal_header]: NEW_PORTAL_HEADER })}>
                <DataList goTo={noop} initialItemId={initialItemId} />
            </div>
        </div>
    );
});
